export default "__VITE_ASSET__BkrotjT$__"